<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import EvolutionSyncHistoryDialog from 'dashboard/components/EvolutionSyncHistoryDialog.vue';

defineProps({
  inboxId: {
    type: [Number, String],
    required: true,
  },
});

const { t } = useI18n();

const dialogRef = ref(null);
</script>

<template>
  <SettingsFieldSection
    :label="t('INBOX_MGMT.EVOLUTION_MANUAL_SYNC.LABEL')"
    :help-text="t('INBOX_MGMT.EVOLUTION_MANUAL_SYNC.HELP_TEXT')"
  >
    <NextButton
      slate
      :label="t('INBOX_MGMT.EVOLUTION_MANUAL_SYNC.BUTTON_TEXT')"
      @click="dialogRef?.open()"
    />

    <EvolutionSyncHistoryDialog ref="dialogRef" :inbox-id="inboxId" />
  </SettingsFieldSection>
</template>
